import { Box, Tab, Tabs } from '@mui/material';
import React, { useState } from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import { WaitlistAnalytics } from '../../components/admin/WaitlistAnalytics';
import { WaitlistManagement } from '../../components/admin/WaitlistManagement';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`waitlist-tabpanel-${index}`}
      aria-labelledby={`waitlist-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `waitlist-tab-${index}`,
    'aria-controls': `waitlist-tabpanel-${index}`,
  };
}

const WaitlistManagementPage = () => {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  return (
    <AdminLayout>
      <Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs 
            value={tabValue} 
            onChange={handleTabChange} 
            aria-label="waitlist management tabs"
            sx={{
              '& .MuiTab-root': {
                textTransform: 'none',
                fontSize: '1rem',
                fontWeight: 500,
              },
            }}
          >
            <Tab label="Management" {...a11yProps(0)} />
            <Tab label="Analytics" {...a11yProps(1)} />
          </Tabs>
        </Box>
        
        <TabPanel value={tabValue} index={0}>
          <WaitlistManagement />
        </TabPanel>
        
        <TabPanel value={tabValue} index={1}>
          <WaitlistAnalytics />
        </TabPanel>
      </Box>
    </AdminLayout>
  );
};

export default WaitlistManagementPage; 